<div class="quote">
  @if (loadingQuote) {
    <div class="quote--loader">
      <div class="loading-animation"></div>
    </div>
  }
  <div class="quote--header">
    <h6 class="quote-name">{{ quoteName(quote) }}</h6>
    <button type="submit" class="button button--link button--delete-quote"
      [attr.data-test]="'button-delete-' + quote.id"
      (click)="deleteQuote(quote.id, quote.attributes.totalItemsQuantity)">
      {{ 'multi-cart.delete-quote' | translate }}
      <span class="icon-close"></span>
    </button>
  </div>
  <div class="quote--body">
    <div class="quote-price">
      {{ 'multi-cart.your-annual-price' | translate }}<br>
      <strong>
        {{ quote.attributes.totals?.cpqNetPriceTotal | currency: currency }}
      </strong>
    </div>
    @if (quote.itemDetails[0]?.attributes.sku) {
      <div class="quote-image">
        <img [src]="getImageForQuote(quote.itemDetails[0]?.attributes.sku)" alt="{{ quote.itemDetails[0]?.attributes.sku }}">
      </div>
    }
    <div class="quote-items">
      <h6 class="quote-item-name">{{ quote.id }}</h6>
      @if (quote.itemDetails?.length > 0) {
        <strong>
          {{ singularOrPlural(quote.itemDetails.length, 'orders-page.item') | translate: {number: quote.itemDetails.length} }}
        </strong>
        <span>{{ 'mini-cart.equType' | translate:{count: calculateEquType(quote.itemDetails)} }}</span>
        <span>{{ 'mini-cart.fls' | translate:{count: quote.itemDetails.length} }}</span>
      } @else {
        <span>{{ 'multi-cart.no-quote-items' | translate }}</span>
      }
    </div>
    <div class="quote-actions">
      <button type="submit" class="button button--primary" [attr.data-test]="'button-continue-' + quote.id"
        (click)="switchQuote(quote.id, true)">
        {{ 'multi-cart.continue' | translate }}
      </button>
      <button type="submit" class="button" [attr.data-test]="'button-select-' + quote.id"
        (click)="switchQuote(quote.id)">
        {{ 'multi-cart.select' | translate }}
      </button>
    </div>
  </div>
</div>
